@if (!loading) {
  <form [formGroup]="dynamicForm" onsubmit="return false" class="mb-m">
    <div class="row">
      @for (field of fieldsList.fields_list; track field) {
        @switch (field.type) {
          @case ('TEXTAREA') {
            <div class="col-md-{{field.col}}">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>{{field.label}}</mat-label>
                <textarea matInput
                [formControlName]="'field'+field.id"></textarea>
              </mat-form-field>
            </div>
          }
          @case ('RADIO') {
            <div class="col-md-{{field.col}} mb-m">
              <h4 class="pb-0 mt-m">{{field.label}}</h4>
              <mat-radio-group [formControlName]="'field'+field.id" [required]="field.required">
                @for (option of field.options; track option) {
                  <mat-radio-button
                  [value]="option.value">{{option.text}}</mat-radio-button>
                }
              </mat-radio-group>
            </div>
          }
          @case ('SELECT') {
            <div class="col-md-{{field.col}}">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>{{field.label}}</mat-label>
                <mat-select tabindex="1"
                  [formControlName]="'field'+field.id">
                  @for (option of field.options; track option) {
                    <mat-option
                      [value]="option.value">
                      {{option.text}}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          }
          @case ('CHECKBOX') {
            <div appearance="outline" class="col-md-{{field.col}} my-0">
              <mat-checkbox type="checkbox"
                [formControlName]="'field'+field.id"
              [required]="(field.required) ? 'required': false">{{field.label}}</mat-checkbox>
              @if (getFormError('field'+field.id)) {
                <mat-error>* Pflichtfeld</mat-error>
              }
            </div>
          }
          @case ('INPUT') {
            <div class="col-md-{{field.col}}">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>{{field.label}}</mat-label>
                <input matInput [formControlName]="'field'+field.id">
              </mat-form-field>
            </div>
          }
          @case ('TEXT') {
            <div class="col-md-{{field.col}} mb-m">
              <p [innerHTML]="field.label"></p>
            </div>
          }
        }
      }
    </div>
    <div class="row">
      <div class="col-md-12">
        <button mat-flat-button color="primary" class="btn btn-primary mt-0" type="submit"
        (click)="submit(); $event.stopPropagation()">{{fieldsList.submit_label}}</button>
      </div>
    </div>
  </form>
}

<!--<notification *ngIf="successText" type="success" html="{{fieldsList.success_text}}" class="mt-m"></notification>-->
<!--<notification *ngIf="errorText" type="success" message="Ihre Anfrage konnte nicht gesendet werden. Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut." class="mt-m"></notification>-->
